/* Alpine story: muted viewport autoplay and looping, with accessible native controls. */
(() => {
  document.querySelectorAll('[data-alpine-story]:not([data-story-bound])').forEach(root => {
    root.dataset.storyBound = 'true';
    const mobile = matchMedia('(max-width: 749px)');
    root.querySelectorAll('[data-story-responsive]').forEach(video => {
      const selectMedia = () => {
        const format = mobile.matches ? 'mobile' : 'desktop';
        const src = video.dataset[format + 'Src'];
        if (video.getAttribute('src') === src) return;
        video.pause();
        video.poster = video.dataset[format + 'Poster'];
        video.src = src;
        video.load();
      };
      selectMedia();
      mobile.addEventListener('change', selectMedia);
    });
    const videos = [...root.querySelectorAll('video')];
    const motion = matchMedia('(prefers-reduced-motion: reduce)');
    const visible = new Set();
    const pausedByUser = new WeakSet();
    const systemPause = video => { video.dataset.storySystemPause = 'true'; video.pause(); };
    const play = video => {
      if (document.hidden || motion.matches || !visible.has(video) || pausedByUser.has(video) || document.querySelector('dialog[open]')) return;
      video.play().catch(() => {});
    };
    const pause = () => videos.forEach(systemPause);
    const observer = new IntersectionObserver(entries => entries.forEach(entry => {
      if (entry.isIntersecting && entry.intersectionRatio >= .25) { visible.add(entry.target); play(entry.target); }
      else { visible.delete(entry.target); systemPause(entry.target); }
    }), { threshold: [0, .25] });
    videos.forEach(video => {
      video.loop = true; video.muted = true; video.defaultMuted = true;
      video.playsInline = true; video.autoplay = !motion.matches; video.controls = true;
      video.playbackRate = 1;
      video.addEventListener('pause', () => {
        if (video.dataset.storySystemPause === 'true') { delete video.dataset.storySystemPause; return; }
        if (visible.has(video) && !video.ended && video.readyState >= 2) pausedByUser.add(video);
      });
      video.addEventListener('play', () => { pausedByUser.delete(video); delete video.dataset.storySystemPause; });
      video.addEventListener('loadeddata', () => play(video));
      observer.observe(video);
    });
    document.addEventListener('visibilitychange', () => document.hidden ? pause() : visible.forEach(play));
    document.addEventListener('alpine:zoom-open', pause);
    document.addEventListener('alpine:zoom-close', () => visible.forEach(play));
    motion.addEventListener('change', () => motion.matches ? pause() : visible.forEach(play));
    root.querySelectorAll('[data-story-size]').forEach(button => button.addEventListener('click', event => {
      // Native tooltip closes on document clicks outside its content.
      event.stopPropagation();
      const trigger = document.querySelector('[data-alpine-size-guide] tool-tip-trigger');
      if (!trigger) return;
      trigger.click();
      const popup = document.querySelector('tool-tip');
      if (!popup) return;
      const restore = new MutationObserver(() => {
        if (popup.dataset.toolTipOpen !== 'true') {
          restore.disconnect();
          // Follow the native guide's own close and focus handling.
          requestAnimationFrame(() => requestAnimationFrame(() => button.focus({ preventScroll: true })));
        }
      });
      restore.observe(popup, { attributes: true, attributeFilter: ['data-tool-tip-open'] });
    }));
    const themeId = new URL(location.href).searchParams.get('preview_theme_id') || (window.Shopify?.theme?.role === 'unpublished' ? String(window.Shopify.theme.id) : '');
    // Resolve image, visible context and native variant as one canonical target.
    const colourIndex = data => data.options.findIndex(name => /^(color|colour|顏色|外套顏色)$/i.test(name));
    const colourKey = (value, id) => window.catalogColourKey?.(value, String(id)) || value;
    const currentDataNode = document.querySelector('[data-alpine-native-data],[data-alpine-preview-data]');
    const current = currentDataNode ? JSON.parse(currentDataNode.textContent) : null;
    const recommendations = [...root.querySelectorAll('[data-story-recommendation]')].map(card => ({card, data: JSON.parse(card.querySelector('[data-story-recommendation-data]').textContent)}));
    // FIT uses only a verified EC binding for the selected canonical product, presentation and colour.
    const fit = root.matches('[data-story-version="pdp-family-66"],[data-story-version="pdp-additional-67"]') ? root.querySelector('.alpine-story-fit video') : null;
    const fitCaption = fit?.closest('.alpine-story-film')?.querySelector('.alpine-story-caption');
    const fixedFit = fit ? {src:fit.querySelector('source')?.src || fit.src,poster:fit.poster,label:fit.getAttribute('aria-label'),caption:fitCaption?.textContent} : null;
    const fitColourKey = value => ['8817047601348','8817047666884'].includes(String(current?.id)) && value === '棕' ? '土星棕' : colourKey(value,current?.id);
    const syncFit = (context,colour) => {
      if(!fit || !current)return;
      const groups=current.gallery?.contexts?.[context] || {};
      const media=groups[colour] || groups[colourKey(colour,current.id)] || [];
      const clip=media.find(m=>m.type==='video' && m.mappingVerified===true && m.deploymentVerified===true && String(m.sourceProductId)===String(current.id) && m.presentation===context && fitColourKey(m.nativeColour)===fitColourKey(colour));
      const cover=media.find(m=>m.type==='image' && m.src);
      const src=clip&&cover?clip.src:fixedFit.src;
      const poster=clip&&cover?cover.src:fixedFit.poster;
      const en=document.documentElement.lang.startsWith('en');
      const label=en?(clip&&cover?(context==='unisex'?'In use':context==='women'?'Women':'Men')+' / '+(window.catalogDisplayLabel?.(colour)||colour):'Fit demonstration'):clip&&cover?(context==='unisex'?'穿戴示意':context==='women'?'女裝實穿':'男裝實穿')+'／'+colour:'固定版型示範：'+fixedFit.caption.split(' · ')[0].replace(/商品實穿影片.*$/, '').trim();
      if(fit.dataset.fitSrc!==src){systemPause(fit);fit.querySelectorAll('source').forEach(s=>s.remove());fit.src=src;fit.poster=poster;fit.load();fit.dataset.fitSrc=src;}
      fit.setAttribute('aria-label',current.title+'・'+label);
      if(fitCaption)fitCaption.textContent=label+(en?' · Fit and movement film':' · 商品實穿影片');
      fit.dataset.fitMode=clip&&cover?'selected':'fixed';fit.dataset.fitPresentation=clip&&cover?context:'';fit.dataset.fitColour=clip&&cover?colour:'';
    };
    const syncRecommendations = () => {
      const params = new URL(location.href).searchParams;
      const form = document.querySelector('[data-alpine-native-pdp] form[action*="/cart/add"]');
      const context = form?.querySelector('[name="properties[_tz_presentation]"]')?.value || params.get('presentation') || Object.keys(current?.gallery?.contexts || {})[0];
      const sourceVariant = current?.variants.find(variant => String(variant.id) === String(form?.querySelector('[name=id]')?.value || params.get('variant')));
      const sourceColour = sourceVariant?.options[colourIndex(current)];
      syncFit(context,sourceColour);
      recommendations.forEach(({card, data}) => {
        // Curated pairings for the unisex glove: each card names its own photographed presentation.
        // Other products retain strict presentation matching; no missing-gallery fallback.
        const glovePairings = {'8658218188996':'men','8817048322244':'women'};
        const recommendationContext = String(current?.id) === '8729402441924' && context === 'unisex'
          ? (glovePairings[String(data.id)] || context) : context;
        const groups = data.gallery?.contexts?.[recommendationContext];
        const ci = colourIndex(data);
        const options = groups && ci >= 0 ? data.variants.flatMap(variant => {
          const colour = variant.options[ci];
          const photos = groups[colour] || groups[colourKey(colour, data.id)] || [];
          const cover = photos.find(media => media.type === 'image' && (() => { try { return new URL(media.src, location.href).protocol === 'https:'; } catch { return false; } })());
          return (variant.available || card.dataset.storyPreviewOnly === 'true') && variant.price > 0 && cover ? [{variant, colour, cover}] : [];
        }) : [];
        const choice = options.find(option => sourceColour && colourKey(option.colour, data.id) === colourKey(sourceColour, current.id)) || options.find(option => /^(經典黑|黑)$/.test(option.colour)) || options[0];
        card.hidden = !choice;
        if (!choice) return;
        const url = new URL(card.dataset.storyPath || data.url, location.origin);
        url.searchParams.set('view', card.dataset.storyView || 'alpine-native');
        url.searchParams.set('presentation', recommendationContext);
        url.searchParams.set('variant', choice.variant.id);
        if (themeId) url.searchParams.set('preview_theme_id', themeId);
        const link = card.querySelector('[data-story-recommendation-link]');
        const image = link.querySelector('img');
        const label = String(data.id) === '8817047699652' ? '替換鏡片單售／安裝示意' : (recommendationContext === 'unisex' ? '穿戴示意' : recommendationContext === 'women' ? '女裝實穿' : '男裝實穿') + '／' + choice.colour;
        link.href = url.pathname + url.search;
        image.src = choice.cover.src;
        image.alt = link.querySelector('h3').textContent + ' ' + label;
        card.querySelector('[data-story-recommendation-context]').textContent = label;
        card.dataset.variant = String(choice.variant.id);
        card.dataset.presentation = recommendationContext;
        card.dataset.colour = choice.colour;
      });
    };
    syncRecommendations();
    const scheduleRecommendations = () => requestAnimationFrame(() => requestAnimationFrame(syncRecommendations));
    document.querySelector('[data-alpine-native-pdp]')?.addEventListener('variantChange', scheduleRecommendations);
    document.querySelector('[data-alpine-native-pdp]')?.addEventListener('change', scheduleRecommendations);
    document.querySelector('[data-alpine-preview]')?.addEventListener('alpinePreviewChange', scheduleRecommendations);
    window.addEventListener('popstate', scheduleRecommendations);
    root.querySelectorAll('[data-story-product-link],[data-story-hub-link]').forEach(link => {
      if (!link.hasAttribute('href')) return;
      const url = new URL(link.href);
      if (themeId) url.searchParams.set('preview_theme_id', themeId);
      link.href = url.pathname + url.search;
    });
  });
})();


